import { createTheme } from '@mui/material/styles';



// Function to generate the theme dynamically
export const getTheme = () => {
  // Fetch value from localStorage (assuming 'subdomain' is stored there)
  const subdomain = localStorage.getItem('host') || 'default';

  // Define default palette values
  let primaryColor = '#3b469c';
  let backgroundColor = '#3b469c';
  let switchColor = '#3b469c';
  let primaryBackground = '#ffffff';
  let secondaryBackground = '#FFFFFF';  


  // Define and return the theme object
  return createTheme({
    palette: {
      primary: {
        main: primaryColor,  // Dynamically set primary color
      },
      background: {
        default: backgroundColor,  // Dynamically set background color
      },
      switchColor: {
        main: switchColor,  // Dynamically set switch color
      },
      appbar: {
        default: '#ffffff',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: primaryBackground,
          },
          secondary: {
            backgroundColor: secondaryBackground, // Ensure the body has the same background colour
          },
        },
      },
      MuiStepIcon: {
        styleOverrides: {
          root: {
            '&.Mui-active': {
              color: switchColor,
            },
            '&.Mui-completed': {
              color: switchColor,
            },
          },
        },
      },
    },
  });
};
